import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CountListPageComponent } from './pages/count-list-page/count-list-page.component';
import { MailingRequestsCountListComponent } from './components/lists/mailing-requests-count-list/mailing-requests-count-list.component';

const routes: Routes = [
  { path: 'list/:countType/:status', component: CountListPageComponent },
  {
    path: 'list/mailingRequests',
    component: MailingRequestsCountListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CountsRoutingModule {}
